var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMastercard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 372.48 372.48",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M357.48,71.246H15c-8.271,0-15,6.729-15,15v199.988c0,8.271,6.728,15,15,15h342.48c8.271,0,15-6.729,15-15V86.246 C372.48,77.975,365.752,71.246,357.48,71.246z M86.293,186.24c0-23.568,14.379-43.842,34.824-52.509l-34.718,55.855 C86.335,188.479,86.293,187.364,86.293,186.24z M89.167,204.076l46.162-74.268c2.604-0.366,5.261-0.568,7.964-0.568 c5.59,0,11.068,0.811,16.301,2.369l-59.086,92.232C95.492,218.142,91.6,211.44,89.167,204.076z M107.887,230.86l61.16-95.469 c3.521,1.79,6.867,3.955,9.984,6.473c-10.889,12.254-16.844,27.809-16.844,44.376c0,1.22,0.037,2.434,0.102,3.643l-34.881,51.088 C120.215,238.88,113.606,235.409,107.887,230.86z M143.293,243.24c-1.74,0-3.459-0.091-5.16-0.245l26.49-38.798 c2.689,9.732,7.572,18.726,14.408,26.419C168.92,238.784,156.41,243.24,143.293,243.24z M229.188,243.24 c-14.785,0-28.808-5.651-39.482-15.912c-11.297-10.858-17.518-25.45-17.518-41.088s6.221-30.23,17.518-41.088 c10.675-10.261,24.697-15.912,39.482-15.912c31.43,0,57,25.57,57,57S260.617,243.24,229.188,243.24z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercard);
export default __webpack_public_path__ + "static/media/mastercard.300e51e345b3584ba3c9571ce1a55440.svg";
export { ForwardRef as ReactComponent };